import React from 'react';

import { Link } from 'react-router-dom';

import Session from './Session';

class Film extends React.Component {
  render() {
    return (
      <div className="schedule__film">
        <Link to={'/movie/' + this.props.film.Id}>
          {this.props.film.Rating && <div className="age_restriction">{this.props.film.Rating}</div>}
          <img className="schedule__film__poster" src={this.props.film.innerPoster} alt={this.props.film.Name} />
          <p className="schedule__film__title">{this.props.film.Name}</p>
        </Link>
        <div className="schedule__film__sessions">
          {this.props.film.filteredSessions.map(session =>
            <Session session={session} key={session.CinemaId + "-" + session.Id} dt={session.ShowTime} handleSessionClick={this.props.handleSessionClick} />
          )}

          {/* <div className="session">19:10</div>
          <div className="session">21:10<p className="attr"><span>3D ENG UASUB</span></p></div>
          <div className="session">21:10</div> */}
        </div>
      </div>
    )
  }
}

export default Film


// WEBPACK FOOTER //
// ./src/components/snippets/Film.jsx